import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getDocumentList = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/document-center/docs/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getUploadedByList = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/document-center/docs/uploader-list/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateDocument = ({
  version = 'v1',
  payload,
  uuid,
  params = {},
}) =>
  client
    .request({
      url: `${version}/document-center/docs/${uuid}/`,
      method: RequestMethod.PATCH,
      data: payload,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
